import { render, staticRenderFns } from "./list.vue?vue&type=template&id=6b817e42"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b817e42')) {
      api.createRecord('6b817e42', component.options)
    } else {
      api.reload('6b817e42', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=6b817e42", function () {
      api.rerender('6b817e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/convalescenceSystem/convalescenceInfo/list.vue"
export default component.exports